import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted)

// you can also pass options, check options reference below
//Vue.use(Toasted, Options)